import { HeaderDrawer } from './header-drawer.js';

if (!customElements.get('content-drawer')) {
  customElements.define(
    'content-drawer',
    class ContentDrawer extends HeaderDrawer {
      constructor() {
        super();
        this.drawer = this;
        this.iframe = this.drawer.querySelector('iframe');
        this.embededContent = this.drawer.querySelector('.drawer__content-embeded');

        const contentDrawerLinks = document.querySelectorAll('[data-toggle="content-drawer"]');

        for (var link of contentDrawerLinks) {
          link.addEventListener('click', (e) => this.openDrawerWithUrl(e));
          if (window.location.hash) { 
            const linkTrigger = link.getAttribute('id') || link.dataset.fragmentTrigger;
            if (window.location.hash.substr(1,) == linkTrigger) { 
              this.openDrawer(link);
            }
          }
        }


      }

      openDrawerWithUrl(e) {
        e.preventDefault();
        const linkedClicked = e.currentTarget;
  
        this.openDrawer(linkedClicked);
      }

      openDrawer(link) {
        const heading = link.dataset.heading || '';
        const url = (link.tagName == 'A') ? link.getAttribute('href') : link.dataset.toggleUrl;

        if (!url) {
          return;
        }

        if (link.dataset.narrowDrawer) {
          this.drawer.setAttribute('data-drawer-narrow', "true")
        } else {
          this.drawer.removeAttribute('data-drawer-narrow');
        }

        this.querySelector('.drawer__heading').innerText = heading;

        if (url.startsWith('/')) {
          this.embededContent.innerHTML = '';
          this.drawer.classList.remove('use-iframe');
          this.drawer.showDrawer();

          // Url for the store, so we will use fetch as Shopify adds x-frame-options deny
          fetch(url)
            .then(r => r.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const content = doc.body.querySelector('.main-content');
              if (!content) return;

              this.embededContent.appendChild(content.cloneNode(true));
              this.drawer.classList.add('use-embed');
              this.initEventHandlers();
            }).catch(console.error);
        } else {
          // Use the iframe 
          if (this.iframe.getAttribute('src') == null || this.iframe.getAttribute('src') != url) {
            this.iframe.setAttribute('src', url);

          }
          this.drawer.classList.remove('use-embed');
          this.drawer.classList.add('use-iframe');
          this.drawer.showDrawer();
        }
      }

      initEventHandlers() {
        // A promise wrapper to ensure the chat is initialized
        var initGorgiasChatPromise = window.GorgiasChat
          ? window.GorgiasChat.init()
          : new Promise(function (resolve) {
            window.addEventListener('gorgias-widget-loaded', function () {
              resolve();
            });
          });

        initGorgiasChatPromise.then(function () {
          // Select the chat container and hide it
          var chatElem = document.getElementById('gorgias-chat-container');

          const chatToggleButtons = document.querySelectorAll('.btn--toggle-gorgious');
          for (const chatButton of chatToggleButtons) {
            chatButton.addEventListener('click', function (e) {
              e.preventDefault();
              chatElem.style.display = 'none';
              if (GorgiasChat.isOpen()) {
                window.GorgiasChat.close();
                chatElem.style.display = 'none';
                return;
              }
              window.GorgiasChat.open();
              chatElem.style.display = 'block';
            });
            chatButton.classList.remove('hidden');
          }
        });
      }
    }
  )
}
